<template>
	<el-row>
		<el-col :span="8"></el-col>
		<el-col :span="8" align="center">
			<order-items-search-component
				:disabled="itemsSearchDisabled"
				@search-in-catalogs="onSeachItemInCatalogsPressed"
				@item-picked="onItemPicked"
			/>
			<div style="text-align: left; margin: .3rem 0;">
				<el-link type="primary" :underline="false" @click="onShowAddItemSelectionDemandFormClick">добавить запчасть для подбора</el-link>
			</div>
		</el-col>
		<el-col :span="8"></el-col>
	</el-row>

	<el-row v-if="orderItemDemandsTableData?.length">
		<el-col :span="6"></el-col>
		<el-col :span="12" align="center">			
				<div class="items-selection-demands-holder">
					<el-alert type="warning" show-icon :closable="false">
						<p>В заказе есть запрос на подбор запчастей</p>
					</el-alert>
					<el-table 
						:show-header="false"
						:data="orderItemDemandsTableData">
						<el-table-column>
							<template #default="scope">
								<span v-if="scope.row.partNumber"><strong>{{ scope.row.partNumber.toUpperCase() }}</strong></span>
								<div>
									{{ scope.row.demand }}
								</div>
								<span v-if="scope.row.oemOnly === false"><strong>только замены</strong></span>
								<span v-if="scope.row.oemOnly === true"><strong>только оригинал</strong></span>
							</template>
						</el-table-column>
						<el-table-column  width="155" align="right">
							<template #default="scope">
								<el-button :icon="editIcon" circle
									@click="() => onShowEditItemSelectionDemandClick(scope.row)" />
								<el-button :icon="deleteIcon" circle
									@click="() => deleteItemSelectionDemandClick(scope.row.id)" />
							</template>
						</el-table-column>
					</el-table>
				</div>			
		</el-col>
		<el-col :span="6"></el-col>
	</el-row>

	<el-row>
		<el-col :span="24">
			<el-table 
				style="margin: 1rem 0"
				v-if="orderItemsTableData.length"
				show-summary
				:summary-method="getSummaries"
				:data="orderItemsTableData"
				:default-sort="{ prop: 'partNumber', order: 'descending' }"				
				v-loading="orderItemsLoading">
				<el-table-column label="Деталь" sortable prop="item.partNumber" column-key="partNumber">
					<template #default="scope">
						<el-link v-if="scope.row.isItemValid"
							type="primary"
							@click="() => onItemNumberLinkClick(scope.row)">{{ scope.row.item.partNumber.toUpperCase() }}</el-link>
						<el-text v-else type="danger">
							{{ scope.row.item.partNumber }}
						</el-text>
						<div>
							<el-text type="info" size="small">{{ scope.row.item.name }}</el-text>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="Производитель" prop="item.manufacturer.name" sortable column-key="manufacturer" />
				<el-table-column width="260" label="Группа" column-key="group">
					<template #default="scope">
						<el-tag v-if="!scope.row.isItemValid" type="danger" effect="dark" size="small">
							запчасть не была создана	
						</el-tag>
						<text v-else>{{ scope.row.item.group?.name }}</text>
					</template>
				</el-table-column>
				<el-table-column width="180" label="Ед. измерения" prop="item.measureUnit.name" column-key="measureUnit" />
				<el-table-column width="180" label="Количество">
					<template #default="scope">
						<el-input-number
							:min="0" 
							size="small"
							v-model="scope.row.count"
							@input="() => onItemsCountChange(scope.row)"
						/>
					</template>
				</el-table-column>
				<el-table-column width="180" label="Скидка (+/-, %)">
					<template #default="scope">
						<el-input-number 
							:min="-100" 
							:max="100" 
							size="small"
							v-model="scope.row.discountPercent"
							@input="() => onItemDiscountChange(scope.row)"
						/>
					</template>
				</el-table-column>
				<el-table-column width="180" label="Своя цена">
					<template #default="scope">
						<el-input-number 
							size="small"
							:min="0" 
							:controls="false" 
							:class="{'input-invalid': !scope.row.isItemPriceValid}"
							v-model="scope.row.overridenPrice"
							@input="() => onItemOverridenPriceChange(scope.row)"
						/>
					</template>
				</el-table-column>
				<el-table-column width="180" label="Закупка (р.)" column-key="purchasePrice">
					<template #default="scope">
						<el-input-number 
							size="small"
							:class="{'input-invalid': !scope.row.isItemPriceValid}"
							:min="0" 
							:controls="false" 
							v-model="scope.row.purchasePrice"
							@input="() => onItemPriceChange(scope.row)"
						/>
					</template>
				</el-table-column>
				<el-table-column width="180" label="Маржа (%)" column-key="marginPrice">
					<template #default="scope">
						{{ getMarginPercent(scope.row.purchasePrice) }}
					</template>
				</el-table-column>
				<el-table-column width="180" label="Итого (р.)" prop="totalPrice" column-key="totalPrice" />
				<el-table-column width="74" align="center">
					<template #default="scope">
						<el-button v-if="!scope.row.isItemValid" @click="() => onAddMissingItemClick(scope.row.item)" type="danger" :icon="plusIcon" circle plain />
					</template>
				</el-table-column>
				<el-table-column width="74" align="center">
					<template #default="scope">
						<el-button :icon="deleteIcon" circle
							@click="() => onTableDeleteItemClick(scope.row.vmId)" />
					</template>
				</el-table-column>
			</el-table>
			<div style="margin: 1rem 0; text-align: center;" v-else>
				<el-text type="info">В заказ-наряде нет запчастей ☹️</el-text>
			</div>
		</el-col>
	</el-row>
	
	<el-dialog v-model="isAddOrderItemDemandsDialogVisible" width="700">
		<el-form ref="addItemSelectionDemandForm" :rules="itemDemandFormRules" :model="itemDemandForm">			
			<el-form-item label="Артикул запчасти" label-position="top">
				<el-input placeholder="OEM-номер, замена, кросс" v-model="itemDemandForm.partNumber" max="250" />
			</el-form-item>

			<el-form-item label="Описание запчасти для подбора" label-position="top" prop="demand">
				<el-input
					v-model="itemDemandForm.demand"
					style="width: 100%"
					:autosize="{ minRows: 2, maxRows: 4 }"
					type="textarea"
					max="5000"
					show-word-limit
				/>
			</el-form-item>

			<el-form-item label="Тип запчасти" label-position="top">
				<el-radio-group v-model="itemDemandForm.oemOnly" size="small">
					<el-radio-button :value="0">Любая</el-radio-button>
					<el-radio-button :value="1">Только оригинал</el-radio-button>
					<el-radio-button :value="2">Только замены</el-radio-button>
				</el-radio-group>
			</el-form-item>

			<el-divider style="margin: .3rem 0 1rem" />

			<el-form-item>
				<el-button v-if="itemDemandForm.isCreatingMode == true" @click="onAddItemSelectionDemandClick" type="primary">
					Добавить
				</el-button>
				<el-button v-else @click="onUpdateItemSelectionDemandClick" type="primary">
					Сохранить
				</el-button>
			</el-form-item>
		</el-form>
	</el-dialog>

	<search-items-by-part-number-component
		@item-selected="onItemSelected"
		@closed="() => itemsDialogVisible = false"
		:items="itemsDialogData"
		:part-number="itemsDialogPartNumber"
		:visible="itemsDialogVisible" />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Delete, Edit, Plus, Search } from '@element-plus/icons-vue';
import { ElNotification, FormInstance, FormRules } from 'element-plus';
import TabsDictionary from '@/variables/tabs';
import ApplicationTab from '@/models/ApplicationTab';
import OrderItemModel from '@/models/OrderItemModel';
import ItemModel from '@/models/ItemModel';
import store from '@/store';
import IOrderComponent from './IOrderComponent';
import OrderItemViewModel from '@/ViewModels/OrderItemViewModel';
import eventHelper from '@/helpers/eventsHelper';
import { WatchStopHandle, h, reactive, watch } from 'vue';
import ItemPriceMargin from '@/models/ItemPriceMargin';
import SearchItemsByPartNumberComponent from '../SearchItemsByPartNumberComponent.vue';
import OrderItemsSearchComponent from './OrderItemsSearchComponent.vue';
import ItemsApiHelper from '@/helpers/api/ItemsApiHelper';
import OrderItemSelectionDemandModel from '@/models/OrderItemSelectionDemandModel';

interface IItemSelectionDemandForm {	
	id: number;
	isCreatingMode: boolean;
	partNumber: string | null;
	demand: string;
	oemOnly: number;
}

@Options({
	components: {
		SearchItemsByPartNumberComponent,
		OrderItemsSearchComponent
	},
	props: {
		items: Array,
		itemDemands: Array,
		errors: Array,
	},
	emits: ['update:items', 'update:itemDemands'],
})
export default class OrderItemsComponent extends Vue implements IOrderComponent {
	/** props */
	items!: Array<OrderItemViewModel>;
	itemDemands!: Array<OrderItemSelectionDemandModel>;
	errors!: Array<String>;

	/** constants */
	searchIcon = Search;
	deleteIcon = Delete;
	editIcon = Edit;
	plusIcon = Plus;

	itemsSearchDisabled = false;
	itemsDialogPartNumber = '';
	itemsDialogVisible = false;
	itemsDialogData: Array<ItemModel> = [];

	orderItemsTableData: Array<OrderItemViewModel> = [];
	orderItemsLoading = false;

	orderItemDemandsTableData: Array<OrderItemSelectionDemandModel> | null = null;
	isAddOrderItemDemandsDialogVisible = false;
	
	itemDemandForm: IItemSelectionDemandForm = {
		id: 0,
		isCreatingMode: false,
		partNumber: null,
		demand: '',
		oemOnly: 0
	};

	itemDemandFormRules = reactive<FormRules<any>>({
		demand: [
			{ required: true, message: 'Описание запчасти или задачи подбора не может быть пустым', trigger: 'click', min: 1, max: 5000, }
		]
	});

	watchItemsHandler: WatchStopHandle | null = null;
	watchItemDemandsHandler: WatchStopHandle | null = null;

	mounted() {
		this.watchItemsHandler = watch(
			() => this.items,
			(v: Array<OrderItemViewModel> | null) => {
				if (!v?.length) {
					this.orderItemsTableData = [];
				} else {
					this.orderItemsTableData = v.map(_ => new OrderItemViewModel(_));
				}
			}
		);

		this.watchItemDemandsHandler = watch(
			() => this.itemDemands,
			(v: Array<OrderItemSelectionDemandModel> | null) => {
				if (!v?.length) {
					this.orderItemDemandsTableData = null;
				} else {					
					this.orderItemDemandsTableData = v.map(_ => new OrderItemSelectionDemandModel(_));
				}
			}
		);

		eventHelper.setEventListener('itemsUpdate', this.validateAsync);
		eventHelper.setEventListener('itemUpdated', this.validateAsync);
	}

	unmounted() {
		eventHelper.removeEventListener('itemsUpdate', this.validateAsync);
		eventHelper.removeEventListener('itemUpdated', this.validateAsync);

		if (this.watchItemsHandler) {
			this.watchItemsHandler();
		}

		if (this.watchItemDemandsHandler) {
			this.watchItemDemandsHandler();
		}
	}

	async onItemsCountChange(row: OrderItemViewModel) {
		await this.$nextTick();
		this.calculateTotalPrice(row);
		this.emitItemUpdatedEvent();
	}

	async onItemDiscountChange(row: OrderItemViewModel) {
		await this.$nextTick();
		this.calculateTotalPrice(row);
		this.emitItemUpdatedEvent();
	}
	
	async onItemOverridenPriceChange(row: OrderItemViewModel) {
		await this.$nextTick();		
		this.calculateTotalPrice(row);
		row.isItemPriceValid = !!row.totalPrice;	
		this.emitItemUpdatedEvent();	
	}

	async onItemPriceChange(row: OrderItemViewModel) {
		await this.$nextTick();
		this.calculateTotalPrice(row);
		row.isItemPriceValid = !!row.totalPrice;
		this.emitItemUpdatedEvent();
	}

	/** calculate item's total price */
	calculateTotalPrice(row: OrderItemViewModel) {
		if (!row.overridenPrice) {
			const marginPercent = this.getMarginPercent(row.purchasePrice);
			const marginPrice = row.purchasePrice * (marginPercent / 100 + 1);
			row.marginPercent = marginPercent;			

			if (row.discountPercent != 0) {
				if (row.discountPercent > 0) {				
					row.totalPrice = Math.round((row.count * marginPrice) * ((100 - row.discountPercent) / 100));
				} else {
					row.totalPrice = Math.round((row.count * marginPrice) * (Math.abs(row.discountPercent) / 100 + 1));
				}
			} else {
				row.totalPrice = row.count * marginPrice;
			}
		} else {
			row.totalPrice = row.count * row.overridenPrice;
		}
	}

	/** open 'Add New Item' form when user clicks on '+' against an item that doesn't exist in our database */
	onAddMissingItemClick(item: ItemModel) {		
		const addItemTab = TabsDictionary.itemAdd;
		const addingItemMode = true;
		const addingItemStricrMode = true;
		addItemTab.params = [ {item}, addingItemMode,  addingItemStricrMode];
		store.commit('addTab', addItemTab);
		const newTab = store.getters.newlyAddedTab as ApplicationTab;
		store.commit('changeTab', newTab.id);
	}

	onTableDeleteItemClick(vmId: number) {
		const itemIndex = this.orderItemsTableData.findIndex(_ => _.vmId == vmId)!;
		this.orderItemsTableData.splice(itemIndex, 1);
		this.emitItemUpdatedEvent();
	}

	findExistingItemAsync(itemNumber: string, itemManufacturer: string) : Promise<ItemModel | null> {
		const itemsApiHelper = new ItemsApiHelper(store.getters.jwt);		
		return itemsApiHelper.findItemByPartNumberAndManufacturerName(itemNumber, itemManufacturer);
	}

	/** fires on tables' PartNumber cell is clicked */
	onItemNumberLinkClick(row: OrderItemModel) {
		const addUserTab = TabsDictionary.itemView;
		addUserTab.allowMultiple = true;
		addUserTab.params = [ { item: row.item } ];
		store.commit('addTab', addUserTab);
		const newTab = store.getters.newlyAddedTab as ApplicationTab;
		store.commit('changeTab', newTab.id);
	}

	getMarginPercent(itemPrice: number) : number {		
		let marginPercent = 0;
		const marginMatrix = store.getters.pricesMarginMatrix as Array<ItemPriceMargin>;
		marginMatrix.forEach((m: ItemPriceMargin) => {
			if (itemPrice >= m.price) {
				marginPercent = m.marginPercent;
			} 

			if (itemPrice < m.price) {
				return;
			}
		});

		return marginPercent;
	}

	async validateAsync() : Promise<boolean> {
		if (!this.orderItemsTableData?.length) {
			return true;
		}

		let invalidItems = 0;
		this.orderItemsLoading = true;

		this.orderItemsTableData.forEach(orderItem => {			
			if (!orderItem.item?.id) {			
				try {
					this.findExistingItemAsync(
							orderItem.item!.partNumber!,
							orderItem.item!.manufacturer!.name
						)
						.then(existingItem => {
							if (!existingItem?.id) {
								orderItem.isItemValid = false;
								invalidItems++;
							} else {
								orderItem.item = new ItemModel(existingItem);
								orderItem.isItemValid = true;
							}
						});
				} catch(e) {
					orderItem.isItemValid = false;
					invalidItems++;
					console.error(`Unable to validate existance of item '${orderItem.item?.partNumber}', manufacurer '${orderItem.item?.manufacturer?.name}'`, e);
				}
			} else {
				orderItem.isItemValid = true;
			}
			
			if (!orderItem.overridenPrice && !orderItem.purchasePrice) {
				invalidItems++;	
				orderItem.isItemPriceValid = false;				
			} else {
				orderItem.isItemPriceValid = true;
			}
		});

		this.orderItemsLoading = false;

		return invalidItems == 0;
	}

	getSummaries(param: any) {		
		const { columns, data } = param;	
		const totalColumn = columns.find((_: any) => _.columnKey == 'totalPrice');		
		if (!totalColumn) {
			return;
		}
		const totalColumnIndex: number = totalColumn.no;
		let total = 0;
		data.forEach((row: OrderItemModel) => total += row.totalPrice);

		let totalRow = new Array<any>();

		for(let c = 0; c <= totalColumnIndex; c++) {
			if (c == totalColumnIndex) {
				const el = h('div', { style: { fontSize: '1.06rem' } }, [ `${total} ₽`, ]);
				totalRow.push(el);
			} else {
				totalRow.push('');
			}
		}

		return totalRow;
	}

	findPreviouslyAddedToOrderItemIndex(partNumber: string, manufacturer: string) {
		const partNumberLower = partNumber.toLowerCase();
		const manufactureNameLower = manufacturer.toLocaleLowerCase();
		const existingItemIndex = this.orderItemsTableData
			.findIndex((orderItem: OrderItemModel) => 
				orderItem.item?.partNumber.toLowerCase() == partNumberLower &&
				orderItem.item?.manufacturer?.name.toLowerCase() == manufactureNameLower
			);

		return existingItemIndex;
	}

	emitItemUpdatedEvent() {		
		this.$emit('update:items', this.orderItemsTableData);
	}

	/** fires when user intents to search an item across 3rd-party catalogs */
	onSeachItemInCatalogsPressed(searchQuery: string) {
		this.itemsSearchDisabled = true;
		const itemsApiHelper = new ItemsApiHelper(store.getters.jwt);		
		itemsApiHelper
			.externalSearchItemsByPartNumber(searchQuery)
			.then((foundItems: Array<ItemModel> | null) => {
				if (foundItems == null) {
					ElNotification({
						message: `Ошибка поиска автозапчастей по артикулу '${searchQuery}'`,
						type: 'error',
					});
					return;
				} else if (!foundItems.length) {
					ElNotification({
						message: `Поиск автозапчастей по артикулу '${searchQuery}' не дал результатов`,
						type: 'warning',
					});
					return;
				}

				this.itemsDialogData = foundItems!;
				this.itemsDialogPartNumber = searchQuery;
				this
					.$nextTick()
					.then(() => this.itemsDialogVisible = true);
			})
			.finally(() => this.itemsSearchDisabled = false);
	}

	/** fires when user picked an existing item from local database */
	onItemPicked(item: ItemModel) {
		const previouslyAddedItemIndex = this.findPreviouslyAddedToOrderItemIndex(item.partNumber, item.manufacturer!.name);

		if (previouslyAddedItemIndex >= 0) {
			this.orderItemsTableData[previouslyAddedItemIndex].count += 1;
		} else {			
			const orderItem = new OrderItemViewModel({
				count: 1,				
				item: item,
				manager: store.getters.user.employee,
				isItemValid: true
			});

			this.orderItemsTableData.push(orderItem);
			orderItem.vmId = this.orderItemsTableData!.length;
		}

		this
			.validateAsync()
			.then(() => this.emitItemUpdatedEvent());
	}

	/** fires when user picked an item from external catalog seach results */
	async onItemSelected(item: ItemModel) {
		const previouslyAddedItemIndex = this.findPreviouslyAddedToOrderItemIndex(item.partNumber, item.manufacturer!.name);

		if (previouslyAddedItemIndex >= 0) {			
			this.orderItemsTableData[previouslyAddedItemIndex].count += 1;
		} else {
			const existingItem = await this.findExistingItemAsync(item.partNumber, item.manufacturer!.name);			
			const orderItem = new OrderItemViewModel({
				count: 1,				
				item: existingItem ?? item,
				manager: store.getters.user.employee,
				isItemValid: !!existingItem?.id
			});

			this.orderItemsTableData.push(orderItem);
			orderItem.vmId = this.orderItemsTableData!.length;
		}

		this
			.validateAsync()
			.then(() => this.emitItemUpdatedEvent());
	}

	onShowAddItemSelectionDemandFormClick() {
		this.itemDemandForm.isCreatingMode = true;
		this.itemDemandForm.id = 0;
		this.itemDemandForm.partNumber = null;
		this.itemDemandForm.demand = '';
		this.itemDemandForm.oemOnly = 0;

		this.isAddOrderItemDemandsDialogVisible = true;
	}

	onShowEditItemSelectionDemandClick(selectionDemand: OrderItemSelectionDemandModel) {		
		this.itemDemandForm.isCreatingMode = false;
		this.itemDemandForm.id = selectionDemand.id;
		this.itemDemandForm.partNumber = selectionDemand.partNumber;
		this.itemDemandForm.demand = selectionDemand.demand;

		if (selectionDemand.oemOnly == null) {
			this.itemDemandForm.oemOnly  = 0;
		} else if (selectionDemand.oemOnly == true) {
			this.itemDemandForm.oemOnly = 1;
		} else if (selectionDemand.oemOnly == false) {
			this.itemDemandForm.oemOnly  = 2;
		}

		this.isAddOrderItemDemandsDialogVisible = true;
	}

	deleteItemSelectionDemandClick(selectionDemandId: number) {
		const itemIndex = this.orderItemDemandsTableData!.findIndex(_ => _.id == selectionDemandId);

		if (itemIndex < 0) {
			return;
		}

		this.orderItemDemandsTableData!.splice(itemIndex, 1);		
		this.$emit('update:itemDemands', this.orderItemDemandsTableData);
	}

	onAddItemSelectionDemandClick() {
		const addItemSelectionDemandForm = this.$refs.addItemSelectionDemandForm as FormInstance;
		addItemSelectionDemandForm.validate().then((isFormValid: boolean) => {
			if (!isFormValid) {
				return;
			}

			const orderItemSelectionDemand = new OrderItemSelectionDemandModel({
				partNumber: this.itemDemandForm.partNumber,
				demand: this.itemDemandForm.demand,
				oemOnly: this.mapOemOnlyFlag(this.itemDemandForm.oemOnly)
			});

			if (!this.orderItemDemandsTableData?.length) {
				this.orderItemDemandsTableData = [ orderItemSelectionDemand ];
			} else {
				this.orderItemDemandsTableData.push(orderItemSelectionDemand);
			}

			this.$emit('update:itemDemands', this.orderItemDemandsTableData);
			this.isAddOrderItemDemandsDialogVisible = false;
		});
	}

	onUpdateItemSelectionDemandClick() {
		const addItemSelectionDemandForm = this.$refs.addItemSelectionDemandForm as FormInstance;
		addItemSelectionDemandForm.validate().then((isFormValid: boolean) => {
			if (!isFormValid) {
				return;
			}

			const orderItemSelectionDemand = this.orderItemDemandsTableData!.find(_ => _.id == this.itemDemandForm.id)!;

			orderItemSelectionDemand.partNumber = this.itemDemandForm.partNumber;
			orderItemSelectionDemand.demand = this.itemDemandForm.demand;
			orderItemSelectionDemand.oemOnly = this.mapOemOnlyFlag(this.itemDemandForm.oemOnly);

			this.$emit('update:itemDemands', this.orderItemDemandsTableData);
			this.isAddOrderItemDemandsDialogVisible = false;
		});
	}

	mapOemOnlyFlag(oemOnlyNumber: number) : boolean | null {
		let oemOnly: boolean | null = null;

		if (oemOnlyNumber == 0) {
			oemOnly = null;
		} else if (oemOnlyNumber == 1) {
			oemOnly = true;
		} else {
			oemOnly = false;
		}

		return oemOnly;
	}
}
</script>

<style scoped>
.items-selection-demands-holder {
	border-radius: var(--el-border-radius-base);
	border-color: var(--el-color-warning);
	border-width: 1px;
	border-style: solid;
	padding: .6rem; 
	width: 100%;
	margin: 1rem 0;
}
</style>